import axios from 'axios';

import config from '../config/urlConfig';
import formatAxiosError from '../util/formatAxiosError';
import axiosOptions from '../const/axios-options'

export default class {
  static getAllSlide() {
    return axios
      .get(`${config.app.api}/api/slide/`, axiosOptions)
      .then(response => {
        return response.data.slide;
      })
      .catch(error => {
        let formatedError = formatAxiosError(error);
        throw formatedError;
      });
  }

  static getsSlide() {
    return axios
      .get(`${config.app.api}/api/slide/gets-slider`, axiosOptions)
      .then(response => {
        return response.data.slide;
      })
      .catch(error => {
        console.log(error);
        let formatedError = formatAxiosError(error);
        throw formatedError;
      });
  }
}
